export default "__VITE_ASSET__DcBpAu0e__"